import React from 'react';

const DashboardType1 = (props) => {
  const {firstPageHtml} = props.dashboardComponentData;
  return (
    <>
      <div
        // className="formContainer"
        dangerouslySetInnerHTML={{
          __html: firstPageHtml === undefined ? "<div>در حال بارگزاری</div>" : firstPageHtml,
        }}
      ></div>
    </>
  );
};

export default DashboardType1;
